import { addCoreSetupAuditTrailViewsSyncSlice } from './add';
import { combineReducers } from 'redux';
import { deleteCoreSetupAuditTrailViewsSlice } from './delete';
import { getCoreSetupAuditTrailViewsSlice } from './get';
import { patchCoreSetupAuditTrailViewsSlice } from './patch';
import { postCoreSetupAuditTrailViewsSlice } from './post';
import { removeCoreSetupAuditTrailViewsSyncSlice } from './remove';
import { updateCoreSetupAuditTrailViewsSyncSlice } from './update';

import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';

export const coreSetupAuditTrailViewsReducers = combineReducers({
	delete: deleteCoreSetupAuditTrailViewsSlice.asyncReducers,
	get: joinCollectionReducers([
		getCoreSetupAuditTrailViewsSlice.asyncReducers,
		addCoreSetupAuditTrailViewsSyncSlice.syncReducer,
		removeCoreSetupAuditTrailViewsSyncSlice.syncReducer,
		updateCoreSetupAuditTrailViewsSyncSlice.syncReducer
	], getCoreSetupAuditTrailViewsSlice.asyncState),
	patch: patchCoreSetupAuditTrailViewsSlice.asyncReducers,
	post: postCoreSetupAuditTrailViewsSlice.asyncReducers
});

export const coreSetupAuditTrailViewsWatchers = combineAllWatchers([
	deleteCoreSetupAuditTrailViewsSlice.asyncWatchers,
	getCoreSetupAuditTrailViewsSlice.asyncWatchers,
	patchCoreSetupAuditTrailViewsSlice.asyncWatchers,
	postCoreSetupAuditTrailViewsSlice.asyncWatchers
]);
